import { ReactNode } from 'react';
import { FlexAlignType, StyleProp, View, ViewStyle } from 'react-native';

import { spacing } from '@/constants/theme';

type SpacingToken = keyof typeof spacing;

type Justify =
  | 'flex-start'
  | 'center'
  | 'flex-end'
  | 'space-between'
  | 'space-around'
  | 'space-evenly';

export type StackProps = {
  children: ReactNode;
  /** Gap between children, mapped to `theme.spacing[token]`. Default `'base'` (16). */
  gap?: SpacingToken;
  /** Cross-axis alignment. Default `'stretch'` for vertical stacks. */
  align?: FlexAlignType;
  justify?: Justify;
  flex?: number;
  style?: StyleProp<ViewStyle>;
  testID?: string;
};

export function Stack({
  children,
  gap = 'base',
  align = 'stretch',
  justify,
  flex,
  style,
  testID,
}: StackProps) {
  return (
    <View
      style={[
        {
          flexDirection: 'column',
          gap: spacing[gap],
          alignItems: align,
          justifyContent: justify,
          flex,
        },
        style,
      ]}
      testID={testID}
    >
      {children}
    </View>
  );
}
